import React from 'react';
import { Spinner } from 'reactstrap';

function Loader({text}) {
    return (
        <div className="loader">
        <div className="loader-img text-center">
          <Spinner style={{ width: '6rem', height: '6rem' }}
                                                size="lg" color="danger" />
          <p className="mt-4 text-danger">{text}</p>
        </div>
      </div>
    );
}

export default Loader;
